<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    getUser () {
      this.$store.dispatch('getUser')
    },

    getOffice_channels () {
      this.$store.dispatch('getOffice_channels')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getChannels () {
      this.$store.dispatch('getChannels')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getUser()
      vm.getOffice_channels()
      vm.getOffices()
      vm.getChannels()
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Office_channels.vue?72d8a767